import styled from 'styled-components';
import { screenSm } from 'constants/styles/breakpoints';
import { VoucherCard } from '../CertificationsCounters/styles';

export const RestrictedWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 20px;
  padding-bottom: 20px;
`;

export const RestrictedVoucherCard = styled(VoucherCard)`
  flex: 1 1 auto;
  width: 100%;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  text-align: left;
  padding: 20px;

  ${screenSm} {
    flex: 1 1 auto;
    width: 100%;
  }
`;

export const RestrictedNoVoucherCard = styled(RestrictedVoucherCard)`
  flex: 1 1 auto;
  width: 100%;
  border-left: 10px solid #e52a2a;
`;

export const FomoWrapper = styled.div`
  width: 100%;
`;
